import { app } from '@/main';

export const storeBase = () => {
  /**
   * ...One doToast() To Rule Them All...
   *
   * @param msg
   * @param summary
   * @param error
   * @param life
   */
  const doToast = (msg: string, summary = 'Success', error = false, life = 5000) => {
    app.config.globalProperties.$toast.add({
      severity: error ? 'error' : 'success',
      summary: error ? (summary ? summary : 'Error') : summary,
      detail: msg,
      life,
    });
  };

  return { doToast };
};
